export type Function = (...args: unknown[]) => unknown

export type Yacht3DScene = {
  setMechanicalData: Function
  onSceneLoaded: Function
  initCallouts: Function
  switchExploded: Function
  animate: Function
  renderer?: {
    domElement: HTMLElement
  }
  destroy?: Function
  controls: {
    enableDamping: boolean
    dampingFactor: number
    rotateSpeed: number
    autoRotateSpeed: number
    autoRotate?: boolean
    enableZoom: boolean
    zoomSpeed: number
    minPolarAngle: number
    maxPolarAngle: number
  }
  resetOrbitControls?: Function
}

export function setInitialSceneProperties (scene: Yacht3DScene, autoRotate?: boolean) {
  scene.controls.enableDamping = true
  scene.controls.dampingFactor = 0.05
  scene.controls.rotateSpeed = 0.5
  scene.controls.autoRotateSpeed = 2
  scene.controls.autoRotate = autoRotate
  scene.controls.enableZoom = true
  scene.controls.zoomSpeed = 0.5
  scene.controls.minPolarAngle = Math.PI / 4
  scene.controls.maxPolarAngle = Math.PI / 1.6
}
